export const resizeImage = () => {
    throw new Error(`Can't use this function in a web based app`);
};
export const generateImageAssets = () => {
    throw new Error(`Can't use this function in a web based app`);
};
